import { useState, useEffect } from 'react';
import "flatpickr/dist/themes/material_blue.css";
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import config from "../../Common/Configurations/APIConfig";
import apiService from "../../Common/Configurations/APIService";
import DefaultData from '../../CompanyData/DefaultData';
const HotelDetails = () => {
    const navigate = useNavigate();
    const { state } = useLocation();
    const [pageLoading, setPageLoading] = useState(false);
    const [hotelData, setHotelData] = useState({});
    const [description, setDescription] = useState({});
    const [searchQuery, setSearchQuery] = useState({});
    const [rooms, setRooms] = useState([]);
    const splitRoomPattern = / - /g;
    const responsive = {
        superLargeDesktop: {
            // the naming can be any, depends on you.
            breakpoint: { max: 4000, min: 3000 },
            items: 1
        },
        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: 1
        },
        tablet: {
            breakpoint: { max: 1024, min: 464 },
            items: 1
        },
        mobile: {
            breakpoint: { max: 464, min: 0 },
            items: 1
        }
    };
    const BindHotelData = async (hotelData) => {
        setPageLoading(true);
        const requestData = {
            "commonHotelSearchRequest": searchQuery,
            "commonHotelDetails": hotelData
        }
        var result = await apiService.post(config.GETHOTELROOMS, requestData);
        console.log(result);
        if (result.succeeded) {
            const hotel = result.data?.commonHotelDetails;
            if (hotel !== null) {
                setHotelData(hotel);
                const descriptionData = hotel?.description ? JSON.parse(hotel.description) : {};
                setDescription(descriptionData);
                if (result.data?.commonHotelDetails?.commonHotelAllRooms !== null) {
                    setRooms(result.data?.commonHotelDetails?.commonHotelAllRooms)
                }
            }
        }
        else {
            alert("Error in getting hotel details");
        }
        setPageLoading(false);
    }
    const handleBook = (e, hotelRooms) => {
        e.preventDefault();
        console.log(hotelRooms);
        const requestData = {
            "commonHotelSearchRequest": searchQuery,
            "commonHotelDetails": hotelData,
            "commonHotelAllRooms": hotelRooms
        }
        navigate('/hotel/guests/', { state: { requestData } });
    };
    useEffect(() => {
        if (state === null) {
            navigate("/hotel/search");
        }
        else {
            setSearchQuery(state.searchQuery);
            setHotelData(state.hotel);
            BindHotelData(state.hotel);
        }
    }, []);
    return (
                    <div className="container-fluid mt-2">
                        {pageLoading === true ?
                            <div className="hotels-list">
                                <div className='text-center'>
                                    <img src="/assets/images/loader.webp" width={"64px"} height={"64px"}></img>
                                    Loading, Please wait...</div>
                            </div> :
                            <div className="row">
                                <div className="col-lg-8">
                                    <div className="bg-white shadow-md rounded p-3">
                                        <h4 className="text-dark text-5 me-2">{hotelData.hotelName}<span className="badge bg-primary m-2">{hotelData.propertyType}</span></h4>
                                        <p>
                                            <a
                                                href={`https://www.google.com/maps?q=${hotelData?.geoLocation?.latitude},${hotelData?.geoLocation?.longitude}`}
                                                target="_blank"
                                                rel="noopener noreferrer">
                                                View on Maps
                                            </a>
                                        </p>
                                        <p className="mb-2">
                                            <span className="me-2">
                                                {Array.from({ length: 5 }, (_, i) => (
                                                    <span className='text-warning fs-5' key={i}>{i < hotelData.rating ? '★' : '☆'}</span>
                                                ))}
                                            </span>
                                            <span className="text-black-50">
                                                <i className="ri-map-pin-line" /> {hotelData.address}, {hotelData.cityName}, {hotelData.countryName}, {hotelData.postalCode}
                                            </span>
                                            <span className="text-black-50">
                                                {hotelData?.amenties?.length > 0 && hotelData?.amenties?.map((fruit, index) => (
                                                    <label key={index}>{fruit}</label>
                                                ))}
                                            </span>
                                        </p>
                                        <p className="hotels-amenities d-flex align-items-center mb-2 text-4">
                                            <span className="text-1 text-nowrap px-2"><i className='ri-phone-line me-2'></i>{hotelData.phoneNumber}</span>
                                        </p>
                                        <div className="bg-white shadow-md rounded p-3 p-sm-4 confirm-details">
                                            <div className="owl-carousel owl-theme single-slider mb-3" data-animateout="fadeOut" data-animatein="fadeIn" data-autoplay="true" data-loop="true" data-autoheight="true" data-nav="true" data-items={1}>
                                                <Carousel responsive={responsive}>
                                                    {hotelData?.commonImages?.length > 0 && hotelData.commonImages.map(pi =>
                                                        <div className="item">
                                                            <Link to={pi.imageName} target="_blank">
                                                                <img className="img-fluid" src={pi.imageName} alt="Hotel photo" style={{ minWidth: "800px", maxWidth: "800px", minHeight: "400px", maxHeight: "400px" }} />
                                                            </Link></div>
                                                    )}
                                                </Carousel>
                                            </div>
                                            <nav id="navbar-sticky" className="bg-white pb-2 mb-2 smooth-scroll">
                                                <ul className="nav nav-tabs">
                                                    <li className="nav-item"> <a className="nav-link" href="#choose-room">Rooms</a> </li>
                                                    <li className="nav-item"> <a className="nav-link" href="#hotel-policy">Hotel Policy</a> </li>
                                                </ul>
                                            </nav>
                                            <h4 id="choose-room" className="mb-4 mt-2">Rooms</h4>
                                            {rooms.length > 0 && rooms.map((allrooms, aindex) =>
                                            (hotelData?.commonImages?.length > 0 ?
                                                <>
                                                    <div className="row g-4">
                                                        <div className="col-12 col-md-5">
                                                            <Carousel responsive={responsive}>
                                                                {hotelData?.commonImages?.length > 0 && hotelData?.commonImages.map(pi =>
                                                                    <div className="item">
                                                                        <Link to={pi.imageName} target="_blank">
                                                                            <img className="img-fluid rounded align-top" src={pi.imageName} alt="Hotel photo" style={{ minWidth: "300px", maxWidth: "300px", minHeight: "200px", maxHeight: "200px" }} />
                                                                        </Link></div>
                                                                )}
                                                            </Carousel>
                                                            <div className="d-flex align-items-center mt-3">
                                                                <a data-bs-toggle="modal" data-bs-target={"#cancellation-policy" + aindex} className='me-2' href>Cancellation Policy</a>
                                                                <a data-bs-toggle="modal" data-bs-target={"#room-amenties-" + aindex} className='me-2' href>Room Amenities</a>
                                                            </div>
                                                            <div id={"room-amenties-" + aindex} className="modal fade" role="dialog" aria-hidden="true">
                                                                <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
                                                                    <div className="modal-content">
                                                                        <div className="modal-header">
                                                                            <h5>Amenities</h5>
                                                                        </div>
                                                                        {allrooms?.requestedHotels[0].description !== null && (() => {
                                                                            const parts = allrooms?.requestedHotels[0].description.split(splitRoomPattern);
                                                                            return (
                                                                                <ul className='list-group'>
                                                                                    {parts.map((part, index) => {
                                                                                        const [label, ...rest] = part.split(' - ');
                                                                                        if (!rest.length) {
                                                                                            return <li key={index} className='list-group-item list-group-item-primary'>{label}</li>;
                                                                                        }
                                                                                        return (
                                                                                            <li key={index}>
                                                                                                <strong>{label.trim()}:</strong> {rest.join(' - ').trim()}
                                                                                            </li>
                                                                                        );
                                                                                    })}
                                                                                </ul>
                                                                            );
                                                                        })()}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-12 col-md-7">
                                                            <div className="d-flex align-items-center">
                                                                <span className='badge bg-warning me-2 text-black mb-1 p-1 fs-5'>{DefaultData?.DEFAULTCURRENCY} {(Math.round(allrooms.totalPrice)).toLocaleString('en-IN')} per night</span><span className='badge bg-danger'>{allrooms.bookingType}</span>
                                                                <button onClick={(e) => handleBook(e, allrooms)} className="btn btn-sm btn-primary shadow-none ms-auto">BOOK NOW</button>
                                                            </div>
                                                            {allrooms?.requestedHotels.map((room, index) =>
                                                                <>
                                                                    <p className="text-5"><b>Room</b> {index + 1} : {room.roomType}</p>
                                                                    <p><b>Adults</b> : {room.adults} , <b>Kids</b> : {room.kids}, <b>Meal Type</b> : <span className='badge bg-success'>{room.mealType}</span></p>
                                                                </>
                                                            )}
                                                        </div>
                                                    </div >
                                                    <hr className="my-4" />
                                                </>
                                                : ""))}
                                            <div id="cancellation-policy" className="modal fade" role="dialog" aria-hidden="true">
                                                <div className="modal-dialog modal-dialog-centered" role="document">
                                                    <div className="modal-content">
                                                        <div className="modal-header">
                                                            <h5 className="modal-title">Cancellation Policy</h5>
                                                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                                                        </div>
                                                        <div className="modal-body">
                                                            <ul>
                                                                <li>Non-Refundable on cancellation or No Show</li>
                                                                <li>goCash used in the booking will be non refundable</li>
                                                                <li>Any Add-on charges are Non-Refundable.</li>
                                                                <li>You can not change the Check-in or Check-out date.</li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <h4 id="hotel-policy" className="text-6 mb-3 mt-2">Hotel Details</h4>
                                            <div>
                                                <h5 className="text-xl font-semibold text-gray-700">🛏️ Amenities</h5>
                                                <ul className="list-disc list-inside text-gray-600">
                                                    {hotelData.amenties?.map((item, index) => <li key={index}>{item}</li>)}
                                                    {description?.amenities && <li>{description?.amenities}</li>}
                                                </ul>
                                            </div>
                                            {description?.spoken_languages && (
                                                <div>
                                                    <h5 className="text-xl font-semibold text-gray-700">🗣️ Spoken Languages</h5>
                                                    <p className="text-gray-600">{description?.spoken_languages}</p>
                                                </div>
                                            )}
                                            {/* Dining */}
                                            {description?.dining && (
                                                <div>
                                                    <h5 className="text-xl font-semibold text-gray-700">🍽️ Dining</h5>
                                                    <p className="text-gray-600">{description?.dining}</p>
                                                </div>
                                            )}

                                            {/* Business Amenities */}
                                            {description?.business_amenities && (
                                                <div>
                                                    <h5 className="text-xl font-semibold text-gray-700">💼 Business Amenities</h5>
                                                    <p className="text-gray-600">{description?.business_amenities}</p>
                                                </div>
                                            )}
                                            {/* Room Info */}
                                            {description?.rooms && (
                                                <div>
                                                    <h5 className="text-xl font-semibold text-gray-700">🛌 Room Details</h5>
                                                    <p className="text-gray-600">{description?.rooms}</p>
                                                </div>
                                            )}

                                            {/* Location */}
                                            {description?.location && (
                                                <div>
                                                    <h5 className="text-xl font-semibold text-gray-700">📍 About the Location</h5>
                                                    <p className="text-gray-600">{description?.location}</p>
                                                </div>
                                            )}
                                            {description?.attractions && (
                                                <div>
                                                    <h2 className="text-xl font-semibold text-gray-700">📍 Nearby Attractions</h2>
                                                    <ul className="list-disc list-inside text-gray-600 space-y-1">
                                                        {description?.attractions
                                                            .match(/([A-Za-z0-9\s.'()\-&,]+–?\s\d+(\.\d+)?\s?km)/g)
                                                            ?.map((item, index) => (
                                                                <li key={index}>{item}</li>
                                                            ))}
                                                    </ul>
                                                </div>
                                            )}
                                            {hotelData?.hotelTerms?.length > 0 &&
                                                hotelData.hotelTerms.map((hp, index) => {
                                                    let parsedDescription = {};
                                                    try {
                                                        parsedDescription = JSON.parse(hp.description);
                                                    } catch (error) {
                                                        console.error("Invalid JSON in hotel policy:", hp.description);
                                                    }

                                                    return (
                                                        <div key={index} className="mb-3">
                                                            <h5 className="text-5">{hp.title.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase())}</h5>
                                                            <ul className="mb-0">
                                                                {Object.entries(parsedDescription).map(([key, value], subIndex) => (
                                                                    <li key={subIndex}>
                                                                        <strong>{key.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase())}:</strong> {value}
                                                                    </li>
                                                                ))}
                                                            </ul>
                                                        </div>
                                                    );
                                                })}
                                        </div>
                                    </div>
                                </div>
                                <aside className="col-lg-4 mt-4 mt-lg-0">
                                    <div className="bg-white shadow-md rounded p-3">
                                        <h3 className="text-5 mb-3">Booking Details</h3>
                                        <hr className="mx-n3" />
                                        <ul className="list-unstyled">
                                            <li className="mb-2 fw-500">Destination
                                                <span className="float-end text-4 fw-500 text-dark">{searchQuery?.displayFrom}</span>
                                            </li>
                                            <li className="mb-2 fw-500">CheckIn
                                                <span className="float-end text-4 fw-500 text-dark">{searchQuery?.checkInDate}</span>
                                            </li>
                                            <li className="mb-2 fw-500">CheckOut
                                                <span className="float-end text-4 fw-500 text-dark">{searchQuery?.checkOutDate}</span>
                                            </li>
                                            <li className="mb-2 fw-500">Total Adults
                                                <span className="float-end text-4 fw-500 text-dark">{searchQuery?.totalAdults}</span>
                                            </li>
                                            <li className="mb-2 fw-500">Total Kids
                                                <span className="float-end text-4 fw-500 text-dark">{searchQuery?.totalKids}</span>
                                            </li>
                                            <li className="mb-2 fw-500">Total Rooms
                                                <span className="float-end text-4 fw-500 text-dark">{searchQuery?.totalRooms}</span>
                                            </li>
                                        </ul>
                                    </div>
                                </aside>
                            </div>}
                    </div>
    );
};

export default HotelDetails;
